import { isError, toString } from 'lodash';

export class SyncError extends Error {
  constructor(cause: Error | unknown) {
    super(isError(cause) ? cause.message : toString(cause));
  }
}
